import { registerEffectPreset } from './effectPresets';

const BUILTIN_PRESETS = [
  { id: 'none', label: 'None', cssFilters: [] as string[], priority: 0 },
  { id: 'grayscale', label: 'Grayscale', cssFilters: ['grayscale(100%)'], priority: 10 },
  { id: 'sepia', label: 'Sepia', cssFilters: ['sepia(100%)'], priority: 20 },
  {
    id: 'vintage',
    label: 'Vintage',
    cssFilters: ['sepia(35%)', 'contrast(1.1)', 'brightness(0.95)', 'saturate(0.85)'],
    priority: 30,
  },
  {
    id: 'warm',
    label: 'Warm',
    cssFilters: ['sepia(20%)', 'saturate(1.25)', 'hue-rotate(-8deg)'],
    priority: 40,
  },
  {
    id: 'cool',
    label: 'Cool',
    cssFilters: ['saturate(0.9)', 'hue-rotate(12deg)', 'brightness(1.03)'],
    priority: 50,
  },
];

let bootstrapped = false;

export function bootstrapBuiltinEffectPresets(): void {
  if (bootstrapped) return;
  bootstrapped = true;
  for (const preset of BUILTIN_PRESETS) {
    registerEffectPreset(preset);
  }
}
